import React from "react";
import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import {
  Controller,
  useFormContext,
  useController,
  get,
} from "react-hook-form";
import MuiPhoneNumber from "material-ui-phone-number";
import Error from "../Error/Error";
import { white } from "../../constants/colors";

const useStyles = makeStyles((theme) => ({
  selectStyles: {
    marginBottom: "10px",
    width: "100%",

    "& .MuiPhoneNumber-flagButton": {
      marginTop: "10px",
      zIndex: 1,
    },

    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, 9px) scale(0.75)",
    },

    "& label": {
      paddingLeft: "15px",
    },

    "& label.Mui-focused, & label.MuiFormLabel-filled": {
      paddingLeft: 0,
    },

    "& .MuiOutlinedInput-input": {
      padding: "20px 15px",
    },

    "& .MuiInputAdornment-root": {
      pointerEvents: "none",
    },

    "& .MuiInputBase-root": {
      height: "62px",

      "& input": {
        fontFamily: "sbcBold",
        color: "#282F36",
        fontSize: "16px",
        lineHeight: 1.2,
        marginTop: "10px",
        zIndex: 1,
      },
      "& fieldset": {
        border: "1px solid #D7D7D7",
        borderRadius: "10px",
        top: 0,
        backgroundColor: white,

        "& legend": {
          display: "none",
        },
      },
    },
  },
}));

const CustomPhoneNumber = ({ ...props }) => {
  const { selectStyles } = useStyles();
  const { meta } = useController(props);
  const { control, formState } = useFormContext();
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";

  return (
    <FormControl error={!!errorText} className={selectStyles}>
      <Controller
        {...props}
        as={
          <MuiPhoneNumber
            label="Phone Number"
            data-cy="user-phone"
            defaultCountry={"us"}
            // disableDropdown={true}
            // disableAreaCodes={true}
          />
        }
        variant="outlined"
        control={control}
        defaultValue={props.defaultValue}
      />
      <FormHelperText>
        {errorText && <Error errorMessage={"Must be a valid phone number"} />}
      </FormHelperText>
    </FormControl>
  );
};

export default CustomPhoneNumber;
